/** Up to 2 uppercase initials from a display name, for avatar circles. */
export function initialsFromName(name: string | undefined | null): string {
  return (name || "")
    .normalize("NFC")
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => Array.from(w)[0].toUpperCase())
    .join("");
}
